// extracted by mini-css-extract-plugin
export default {"innerWrapper":"Ay-z","tooltipWrapper":"By-z","icon":"Cy-z","tooltip":"Dy-z","content":"Ey-z"};